import { render, staticRenderFns } from "./edit-volunteerpopup .vue?vue&type=template&id=a3241c3c"
import script from "./edit-volunteerpopup .vue?vue&type=script&lang=js"
export * from "./edit-volunteerpopup .vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports